import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface VentsTabState {
  includeEnded: boolean;
  searchText: string;
}

const formSlice = createGenericFormSlice({
  name: "ventsTab",
  initialState: {} as SliceState<VentsTabState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const ventsTabReducer = formSlice.reducer;
export default ventsTabReducer;
